import React,{useState,useEffect,useContext,createContext,useRef} from 'react'
import {Link,useParams,useNavigate,useLocation} from 'react-router-dom'
import axios from 'axios'
import {Form,Button,Container,Card,Alert,Table,Modal,Navbar,NavDropdown,Nav,Row,Col,Accordion} from 'react-bootstrap'
import ReactCountryFlag from "react-country-flag"
import { Search } from 'react-bootstrap-icons'
import { useReactToPrint } from 'react-to-print'
import BadgeQRCode from './BadgeQRCode'
import './form.css'

export default function Registration() {
    const [visitorsRegistrationSettings,setVisitorsRegistrationSettings]=useState({})
    const [visitorsRegistrationSettingsArray,setVisitorsRegistrationSettingsArray]=useState([])
    const [countries,setCountries]=useState([])
    const [regions,setRegions]=useState([])
    const [companyActivities,setCompanyActivities]=useState([])
    const [jobDescriptions,setJobDescriptions]=useState([])
    const [isLoading,setIsLoading]=useState(false)
    const [isLoadingExhibits,setIsLoadingExhibits]=useState(false)
    const [error,setError]=useState(0)
    const { exURL} = useParams()
    const location = useLocation()
    const isOnsite = location.pathname.endsWith('/onsite')
    const [registration,setRegistration]=useState({})
    const [registeredBy,setRegisteredBy]=useState(isOnsite ? (sessionStorage.getItem('registeredBy') || '') : '')
    const [lang,setLang]=useState(1) //1=GR, 2=ENG
    const [needsAfm,setNeedsAfm]=useState(0)
    const [needsOther,setNeedsOther]=useState(0)
    const [needsReview,setNeedsReview]=useState(0)
    const [otherPlaceHolder,setOtherPlaceHolder]=useState('')
    const [exhibits,setExhibits]=useState([])
    const [semanticExhibits,setSemanticExhibits]=useState([])
    const [selectedExhibits,setSelectedExhibits]=useState([])
    const [showSemanticExhibits,setShowSemanticExhibits]=useState(0)
    const [gdprAnswer,setGdprAnswer]=useState(0)
    const [isRegistered,setIsRegistered]=useState(0)
    const [mailSent,setMailSent]=useState(0)
    const [barCode,setBarCode]=useState('')
    const [showBadge,setShowBadge]=useState(false)
    const [badgeData,setBadgeData]=useState({barCode:'',company:'',name:''})
    const [visitorSearch,setVisitorSearch]=useState('')
    const [searchResults,setSearchResults]=useState([])

    const badgeRef=useRef()

    const handlePrintBadge=useReactToPrint({
        contentRef:badgeRef,
    })

    const borderStyle={border:'1px solid #d0cccaff',padding:'10px',borderRadius:'5px'}

    useEffect(()=>{
        loadData()
    },[])   

    const loadExhibits=(ExCode)=>{
      setIsLoading(true)

      axios.get(process.env.REACT_APP_API_SERVER+'/exhibits/'+ExCode,{
        headers: {
            'Authorization': 'Bearer '+sessionStorage.getItem("token")
            }            
        })
        .then(res=>{

            if (res.data.err==0){

                setExhibits(res.data.result)
                //console.log(res.data.result)    
            }else{
                setError(1)
                alert('Something went wrong. Please try again.')
            }
            

            setIsLoading(false)
        }).catch(err=>{
            console.log(err)
            setError(1)
            setIsLoading(false)
            alert('Error loading data.')
        })         
    }


    const loadRegions=()=>{
      setIsLoading(true)

      axios.get(process.env.REACT_APP_API_SERVER+'/regions',{
        headers: {
            'Authorization': 'Bearer '+sessionStorage.getItem("token")
            }            
        })
        .then(res=>{

            if (res.data.err==0){

                setRegions(res.data.result)
                //console.log(res.data.result)    
            }else{
                setError(1)
                alert('Something went wrong. Please try again.')
            }
            

            setIsLoading(false)
        }).catch(err=>{
            setError(1)
            setIsLoading(false)
            alert('Error loading data')
        })         
    }

    const loadCountries=()=>{
      setIsLoading(true)

      axios.get(process.env.REACT_APP_API_SERVER+'/countries',{
        headers: {
            'Authorization': 'Bearer '+sessionStorage.getItem("token")
            }            
        })
        .then(res=>{

            if (res.data.err==0){

                setCountries(res.data.result)
                setRegistration({...registration,Country:res.data.result.find(item=>item.IsDefault===1).CountryName,County:''})
            }else{
                setError(1)
                alert('Something went wrong. Please try again.')
            }
            

            setIsLoading(false)
        }).catch(err=>{
            setError(1)
            setIsLoading(false)
            alert('Error loading data')
        })         
    }


    const loadData=()=>{
      setIsLoading(true)

      axios.get(process.env.REACT_APP_API_SERVER+'/settings/'+exURL,{
        // headers: {
        //     'Authorization': 'Bearer '+sessionStorage.getItem("token")
        //     }            
        })
        .then(res=>{

            if (res.data.err==0){
                sessionStorage.setItem("token",res.data.token)

                setError(0)
                setVisitorsRegistrationSettings(res.data.result)

                if (res.data.result.CompanyActivitiesFromList==1){
                    loadFields('companyactivities',setCompanyActivities,res.data.result.ExCode)
                }   

                
                if (res.data.result.JobDescriptionFromList==1){
                    loadFields('jobdescriptions',setJobDescriptions,res.data.result.ExCode)
                }    

                
                loadCountries()
                loadRegions()
                loadExhibits(res.data.result.ExCode)
            }else{
                alert('Something went wrong. Please try again.')
                setError(1)
                const savedRegisteredBy=sessionStorage.getItem('registeredBy')
                sessionStorage.clear()
                if (savedRegisteredBy!==null){
                    sessionStorage.setItem('registeredBy',savedRegisteredBy)
                }
            }
            

            setIsLoading(false)
        }).catch(err=>{
            setError(1)
            setIsLoading(false)
            alert('Error loading data')
        })       
    }



    const loadFields=(field,setter,ExCode)=>{
      setIsLoading(true)

      axios.get(process.env.REACT_APP_API_SERVER+'/formfieldoptions/'+field+'/'+ExCode,{
        headers: {
            'Authorization': 'Bearer '+sessionStorage.getItem("token")
            }            
        })
        .then(res=>{

            if (res.data.err==0){

                setter(res.data.result)
            }else{
                setError(1)
                alert('Something went wrong. Please try again.')
            }
            

            setIsLoading(false)
        }).catch(err=>{
            setError(1)
            setIsLoading(false)
            alert('Error loading data')
        })         
    }


   
    const secondLevelExhibits=(parentID)=>{

        return (
            exhibits.sort((a, b) => a.sn - b.sn).filter(exhibit=>exhibit.ParentID==parentID).map(item=>{
                return(
                    <Alert variant="light">

                        <Form.Check // prettier-ignore
                             type="checkbox"
                             checked={selectedExhibits.includes(item.ExhibitCode)}
                             onChange={(e)=>{
                                 if (e.target.checked){ 
                                     setSelectedExhibits([...selectedExhibits,item.ExhibitCode])
                                 } else {
                                     setSelectedExhibits([...selectedExhibits.filter(code=>code!==item.ExhibitCode)])
                                 }   
                             }}
                             label={`${lang==1 ? item.DescrGr : item.DescrEng}`}
                        />   

                    </Alert>
                )
            })
        )
    }

    const exhibitsList1=exhibits.sort((a,b)=>a.ExhibitCode.localeCompare(b.ExhibitCode)).map(item=>{
        return(
            <Alert 
                key={item.ExhibitCode}
                //variant="light"
                variant={selectedExhibits.includes(item.ExhibitCode) ? 'success' : 'light'}
                style={{display: showSemanticExhibits==1 ? selectedExhibits.includes(item.ExhibitCode) ? 'block' : 'none' : 'block'}}
            
            >

            <Form.Check // prettier-ignore
                type="checkbox"
                checked={selectedExhibits.includes(item.ExhibitCode)}
                onChange={(e)=>{
                    if (e.target.checked){ 
                        setSelectedExhibits([...selectedExhibits,item.ExhibitCode])
                    } else {
                        setSelectedExhibits([...selectedExhibits.filter(code=>code!==item.ExhibitCode)])
                    }   
                }}
                label={`${lang==1 ? item.DescrGr : item.DescrEng}`}
            />            
                

                {/* {`${lang==1 ? item.DescrGr : item.DescrEng}`} */}
            </Alert>
        )
    })



    const exhibitsList=exhibits.sort((a, b) => a.sn - b.sn).filter(exhibit=>exhibit.ParentID==0).map((item,index)=>{
        return(
            
            <Accordion defaultActiveKey={item.ExhibitCode} key={item.ExhibitCode} 
                style={{marginBottom:'10px',display: showSemanticExhibits==1 ? selectedExhibits.includes(item.ExhibitCode) ? 'block' : 'none' : 'block'}}
            >
                <Accordion.Item eventKey={index}>
                    <Accordion.Header>
                        
                        <Form.Check // prettier-ignore
                             type="checkbox"
                             checked={selectedExhibits.includes(item.ExhibitCode)}
                             onClick={(e) => e.stopPropagation()}
                             onChange={(e)=>{
                                 if (e.target.checked){ 
                                     setSelectedExhibits([...selectedExhibits,item.ExhibitCode])
                                 } else {
                                     setSelectedExhibits([...selectedExhibits.filter(code=>code!==item.ExhibitCode)])
                                 }   
                             }}
                             label={`${lang==1 ? item.DescrGr : item.DescrEng}`}
                        />   
                    </Accordion.Header>
                    {secondLevelExhibits(item.sn).length>0 &&
                    <Accordion.Body>
                        {secondLevelExhibits(item.sn)}
                    </Accordion.Body>
                    }
                </Accordion.Item>
            </Accordion>
            
            
            
            // <Alert 
            //     key={item.ExhibitCode}
            //     //variant="light"
            //     variant={selectedExhibits.includes(item.ExhibitCode) ? 'success' : 'light'}
            //     style={{display: showSemanticExhibits==1 ? selectedExhibits.includes(item.ExhibitCode) ? 'block' : 'none' : 'block'}}
            
            // >

            // <Form.Check // prettier-ignore
            //     type="checkbox"
            //     checked={selectedExhibits.includes(item.ExhibitCode)}
            //     onChange={(e)=>{
            //         if (e.target.checked){ 
            //             setSelectedExhibits([...selectedExhibits,item.ExhibitCode])
            //         } else {
            //             setSelectedExhibits([...selectedExhibits.filter(code=>code!==item.ExhibitCode)])
            //         }   
            //     }}
            //     label={`${lang==1 ? item.DescrGr : item.DescrEng}`}
            // />            
                

            //     {/* {`${lang==1 ? item.DescrGr : item.DescrEng}`} */}
            // </Alert>
        )
    })



  const countriesList=lang==1 ? countries.sort((a,b)=>a.CountryName.localeCompare(b.CountryName)).map(item=>{
    return(
        <option value={item.CountryName} key={item.CountryNameEng}>{item.CountryName}</option>
        )
    }) : countries.sort((a,b)=>a.CountryNameEng.localeCompare(b.CountryNameEng)).map(item=>{
        return(
        <option value={item.CountryName} key={item.CountryNameEng}>{item.CountryNameEng}</option>
        )
    })


    const countiesList=[...new Set(regions.map(item=>item.County))].map(County=>{
            return(
                <option value={County} key={County}>{County}</option>
            )
    })

    const regionsList=regions.filter(item=>item.County==registration.Region).map(item=>{
            return(
                <option value={item.Region} key={item.Region}>{item.Region}</option>
            )
    })


  const companyActivitiesList=companyActivities.length>0 ? lang==1 ? companyActivities.sort((a,b)=>a.TitleGr.localeCompare(b.TitleGr)).map(item=>{
    return(
        <option value={item.TitleGr} key={item.TitleEng}>{item.TitleGr}</option>
        )
    }) : companyActivities.sort((a,b)=>a.TitleEng.localeCompare(b.TitleEng)).map(item=>{
        return(
        <option value={item.TitleGr} key={item.TitleEng}>{item.TitleEng}</option>
        )
    }) : null

  const jobDescriptionsList=jobDescriptions.length>0 ? lang==1 ? jobDescriptions.sort((a,b)=>a.TitleGr.localeCompare(b.TitleGr)).map(item=>{
    return(
        <option value={item.id} key={item.TitleEng}>{item.TitleGr}</option>
        )
    }) : jobDescriptions.sort((a,b)=>a.TitleEng.localeCompare(b.TitleEng)).map(item=>{
        return(
        <option value={item.id} key={item.TitleEng}>{item.TitleEng}</option>
        )
    }) : null


    const jobChanged=(id)=>{
        if (id==''){
            setNeedsAfm(0)
            setNeedsOther(0)
            setNeedsReview(0)
            setOtherPlaceHolder('')
            setRegistration({...registration,JobID:'',Job:'',OtherJob:''})
            return
        }
       
        setNeedsReview(jobDescriptions.find(item=>item.id==id).NeedsReview)
        setNeedsAfm(jobDescriptions.find(item=>item.id==id).NeedsAfm)
        setNeedsOther(jobDescriptions.find(item=>item.id==id).OtherJobNeeded)
        setOtherPlaceHolder(jobDescriptions.find(item=>item.id==id).PlaceHolder)
        setRegistration({...registration,JobID:id,Job:jobDescriptions.find(item=>item.id==id).TitleGr,NeedsReview:jobDescriptions.find(item=>item.id==id).NeedsReview})
    }


    const countryChanged=(country)=>{
        setRegistration({...registration,Country:country,RegionalUnit:'',Region:''})
    }

    const companyActivityChanged=(activity)=>{
        setIsLoadingExhibits(true)
        setSelectedExhibits([])
        if (activity.length>0){
            const obj={
                keyword:activity,
                items:exhibits 
            }
            
            axios.post(process.env.REACT_APP_API_SERVER+'/exhibits/semantic-filter',obj,{
                headers: {
                    'Authorization': 'Bearer '+sessionStorage.getItem("token")
                    }            
                })
                .then(res=>{
                    //console.log(res.data)
                    setSemanticExhibits(res.data)
                    //setSelectedExhibits([...new Set([...selectedExhibits,...res.data.map(item=>item.ExhibitCode)])])
                    const xSelectedExhibits=res.data

                    
                    const parentSelectedExhibits=xSelectedExhibits.map(xexhibit=>{
                        const parent=exhibits.filter(exhibit=>exhibit.sn==xexhibit.ParentID)
                        if (parent.length==1){
                            return(
                                parent[0].ExhibitCode
                            )
                        }
                    })

                    setSelectedExhibits([...new Set([...res.data.map(item=>item.ExhibitCode),...parentSelectedExhibits])])

                    setRegistration({...registration,CompanyActivity:activity})
                    setIsLoadingExhibits(false)
                    setShowSemanticExhibits(1)
                }).catch(err=>{
                    setRegistration({...registration,CompanyActivity:activity})
                    setIsLoadingExhibits(false)
                })
        }else{
            setRegistration({...registration,CompanyActivity:activity})
            setSelectedExhibits([])
            setSemanticExhibits([])
            setShowSemanticExhibits(0)
            setIsLoadingExhibits(false)
        }

        

    }

  const register=(e)=>{
    e.preventDefault()
    
    const regObj={...registration,ExhibitionName:visitorsRegistrationSettings.ExhibitionName,ExCode:visitorsRegistrationSettings.ExCode,SelectedExhibits:selectedExhibits,gdprAnswer,NeedsReview:needsReview,RegisteredBy:isOnsite ? registeredBy : ''}
    //console.log(regObj)
   
    if (needsAfm==1 && registration.Country=='ΕΛΛΑΔΑ'){
        if (!isValidGreekAFM(registration.Afm)){
            alert(lang==1 ? "Παρακαλώ εισάγετε έγκυρο ΑΦΜ." : "Please enter a valid Tax Identification Number.")
            return
        }       
    }

    setIsLoading(true)
    axios.post(process.env.REACT_APP_API_SERVER,regObj,{
        headers: {
            'Authorization': 'Bearer '+sessionStorage.getItem("token")
            }            
        })
    .then(res=>{
        if (res.data.err==0){
            setIsRegistered(1)
            setMailSent(res.data.mailSent)
            setBarCode(res.data.BarCode)
        }else{
            setMailSent(0)
            setIsRegistered(0)
            setIsLoading(false)
            setBarCode('')
            setError(1)            
        }
        setIsLoading(false)
    }).catch(err=>{
        setMailSent(0)
        setIsRegistered(0)
        setIsLoading(false)
        setBarCode('')
        setError(1)
    })
    //console.log(regObj)
  }

    const searchVisitor=()=>{
      axios.get(process.env.REACT_APP_API_SERVER+'/registrations/'+visitorSearch,{
        headers: {
            'Authorization': 'Bearer '+sessionStorage.getItem("token")
            }
        })
        .then(res=>{
            if (res.data.err==0){
                setSearchResults(res.data.result.filter(item=>item.BarCode.startsWith('09082026')))
            }else{
                alert('Something went wrong. Please try again.')
            }
        }).catch(err=>{
            alert('Error loading data')
        })
    }

    const newVisitor=()=>{
        setRegistration({Country:countries.find(item=>item.IsDefault===1)?.CountryName || '',County:''})
        setSelectedExhibits([])
        setSemanticExhibits([])
        setShowSemanticExhibits(0)
        setNeedsAfm(0)
        setNeedsOther(0)
        setNeedsReview(0)
        setOtherPlaceHolder('')
        setGdprAnswer(0)
        setBarCode('')
        setMailSent(0)
        setIsRegistered(0)
    }

    function isValidGreekAFM(afm) {
        if (!/^\d{9}$/.test(afm)) return false;

        const digits = afm.split('').map(Number);
        const checkDigit = digits[8];

        let sum = 0;
        for (let i = 0; i < 8; i++) {
            sum += digits[i] * Math.pow(2, 8 - i);
        }

        const mod = (sum % 11) % 10;
        return mod === checkDigit;
    }


  return (
    <Container style={{marginTop:'5px',marginBottom:'200px'}}>
        {isLoading &&
            <Alert variant="warning" className="mt-3">
                Loading data. Please wait...
            </Alert>
        }
        {!isLoading &&
        <>
        {error==1 &&
            <Alert variant="danger" className="mt-3">
                Error loading data. Please try again later.
                <br/><br/>
                <Button variant="danger" onClick={()=>window.location.reload(false)}>Reload Page</Button>
            </Alert>
        }

        {error==0 && 
            <>
            <Navbar bg="light" expand="sm">
            <Container>
                
                <Nav className="ms-auto d-flex flex-row gap-3">
                    <Nav.Link onClick={() => setLang(1)}>
                        <ReactCountryFlag svg countryCode="GR" style={{ fontSize: lang==1 ? "2.5rem" : "1.5rem" }} />
                    </Nav.Link>

                    <Nav.Link onClick={() => setLang(2)}>
                        <ReactCountryFlag svg countryCode="GB" style={{ fontSize: lang==2 ? "2.5rem"  : "1.5rem" }} />
                    </Nav.Link>


                </Nav>
            </Container>
            </Navbar>                
                
                <img src={visitorsRegistrationSettings.TopBanner} width="100%" style={{marginBottom:'20px'}}/>

                {isOnsite &&
                <Alert variant="secondary" className="d-flex gap-4 justify-content-center">
                    <a href="https://services-helexpo.gr/exhibitorcards/" target="_blank" rel="noopener noreferrer">EXHIBITOR CARDS</a>
                </Alert>
                }

                {isOnsite &&
                <Form.Group className="mb-3" style={{...borderStyle,position:'relative'}}>
                    <Form.Control
                        type="text"
                        placeholder={lang==1 ? "Αναζήτηση επισκέπτη..." : "Search visitor..."}
                        value={visitorSearch}
                        onChange={(e)=>setVisitorSearch(e.target.value)}
                        onKeyDown={(e)=>{if (e.key=='Enter'){e.preventDefault();searchVisitor()}}}
                        style={{paddingRight:'40px'}}
                    />
                    {visitorSearch.trim().length>0 &&
                    <Button
                        variant="link"
                        onClick={searchVisitor}
                        style={{position:'absolute',right:'18px',top:'50%',transform:'translateY(-50%)',padding:0,color:'#555',lineHeight:0}}
                    >
                        <Search size={20}/>
                    </Button>
                    }
                </Form.Group>
                }

                {/* <Alert variant='success'>
                    <h2>{visitorsRegistrationSettings.ExhibitionName}</h2>
                </Alert> */}

                {isRegistered==0 &&
                <Form onSubmit={register}>
                    {isOnsite &&
                    <Alert variant='danger'>
                    <Form.Group className="mb-3" style={borderStyle}>
                        <Form.Label className="form-label-custom">{lang==1 ? "Καταχωρήθηκε από" : "Registered By"}</Form.Label>
                        <Form.Control type="text" required value={registeredBy} onChange={(e)=>{
                            setRegisteredBy(e.target.value)
                            sessionStorage.setItem('registeredBy',e.target.value)
                        }}/>
                    </Form.Group>
                    </Alert>
                    }

                    <Form.Group className="mb-3" style={borderStyle}>
                        <Form.Label className="form-label-custom">{lang==1 ? "Χώρα" : "Country"}</Form.Label>
                        <Form.Select required value={registration.Country} onChange={(e)=>countryChanged(e.target.value)}>
                        <option value=''>{lang==1 ? "[ΕΠΙΛΕΞΤΕ ΧΩΡΑ]" : "[SELECT COUNTRY]"}</option>
                        {countriesList}
                        </Form.Select>
                    </Form.Group>

                    <Form.Group className="mb-3" style={borderStyle}>
                        <Form.Label className="form-label-custom">{lang==1 ? "Όνοματεπώνυμο" : "Full Name"}</Form.Label>
                        <Form.Control type="text"  required value={registration.PName} onChange={(e)=>setRegistration({...registration,PName:e.target.value})}/>
                    </Form.Group> 

                    {visitorsRegistrationSettings.JobDescriptionFromList==1 ?
                    <Form.Group className="mb-3" style={borderStyle}>
                        <Form.Label className="form-label-custom">{lang==1 ? "Ιδιότητα" : "Job Description"}</Form.Label>
                        <Form.Select required value={registration.JobID} onChange={(e)=>jobChanged(e.target.value)}>
                        <option value=''>{lang==1 ? "[ΕΠΙΛΕΞΤΕ ΙΔΙΟΤΗΤΑ]" : "[SELECT JOB DESCRIPTION"}</option>
                        {jobDescriptionsList}
                        </Form.Select>
                    </Form.Group>  
                    :
                    <Form.Group className="mb-3" style={borderStyle} >
                        <Form.Label className="form-label-custom">{lang==1 ? "Ιδιότητα" : "Job Description"}</Form.Label>
                        <Form.Control type="text"  required value={registration.Job} onChange={(e)=>setRegistration({...registration,Job:e.target.value})}/>
                    </Form.Group>  
                    }   

                    {visitorsRegistrationSettings.JobDescriptionFromList==1  && needsOther==1 &&
                    <Form.Group className="mb-3" style={borderStyle}>

                        <Form.Control type="text" placeholder={otherPlaceHolder} required value={registration.OtherJob} onChange={(e)=>setRegistration({...registration,OtherJob:e.target.value})}/>
                    </Form.Group>   
                    }



                    {registration.Country=='ΕΛΛΑΔΑ' &&
                        <>
                            <Form.Group className="mb-3" style={borderStyle}>
                                <Form.Label className="form-label-custom">{lang==1 ? "Περιφέρεια" : "Region"}</Form.Label>
                                <Form.Select required value={registration.Region} onChange={(e)=>setRegistration({...registration,Region:e.target.value})}>
                                <option value=''>[ΕΠΙΛΕΞΤΕ ΠΕΡΙΦΕΡΕΙΑ]</option>
                                {countiesList}
                                </Form.Select>
                            </Form.Group>

                            {registration.Region &&
                            
                                <Form.Group className="mb-3" style={borderStyle}>
                                    <Form.Label className="form-label-custom">{lang==1 ? "Περιφερειακή Ενότητα" : "Regional Unit"}</Form.Label>
                                    <Form.Select required value={registration.RegionalUnit} onChange={(e)=>setRegistration({...registration,RegionalUnit:e.target.value})}>
                                    <option value=''>[ΕΠΙΛΕΞΤΕ ΠΕΡΙΦΕΡΕΙΑΚΗ ΕΝΟΤΗΤΑ]</option>
                                    {regionsList}
                                    </Form.Select>
                                </Form.Group>                            
                            }
                        </>
                    }
                    <Form.Group className="mb-3" style={borderStyle}>
                        <Form.Label className="form-label-custom">{lang==1 ? "Πόλη" : "City"}</Form.Label>
                        <Form.Control type="text"  required value={registration.City} onChange={(e)=>setRegistration({...registration,City:e.target.value})}/>
                    </Form.Group>  

                    <Form.Group className="mb-3" style={borderStyle}>
                        <Form.Label className="form-label-custom">{lang==1 ? "Επωνυμία Εταιρίας" : "Company Name"}</Form.Label>
                        <Form.Control type="text"  required value={registration.Company} onChange={(e)=>setRegistration({...registration,Company:e.target.value})}/>
                    </Form.Group>  




                    {visitorsRegistrationSettings.JobDescriptionFromList==1  && needsAfm==1 && registration.Country=='ΕΛΛΑΔΑ' &&
                    <Form.Group className="mb-3" style={borderStyle}>
                        <Form.Label className="form-label-custom">{lang==1 ? "ΑΦΜ" : "Tax Identification Number"}</Form.Label>
                        <Form.Control type="text" placeholder={lang==1 ? "ΑΦΜ" : "Tax Identification Number"} required value={registration.Afm} onChange={(e)=>setRegistration({...registration,Afm:e.target.value})}/>
                    </Form.Group>
                    }   

                    <Form.Group className="mb-3" style={borderStyle}>
                        <Form.Label className="form-label-custom">Email</Form.Label>
                        <Form.Control type="email"  required value={registration.Email} onChange={(e)=>setRegistration({...registration,Email:e.target.value})}/>
                    </Form.Group>  

                    <Form.Group className="mb-3" style={borderStyle}>
                        <Form.Label className="form-label-custom">{lang==1 ? "Τηλέφωνο" : "Telephone"}</Form.Label>
                        <Form.Control type="text"  required value={registration.Telephone} onChange={(e)=>setRegistration({...registration,Telephone:e.target.value})}/>
                    </Form.Group> 
                
                    {visitorsRegistrationSettings.CompanyActivitiesFromList==1 ?
                    <Form.Group className="mb-3" style={borderStyle}>
                        {!isLoadingExhibits ?
                            <>
                            <Form.Label className="form-label-custom">{lang==1 ? "Δραστηριότητα Εταιρίας" : "Company Activity"}</Form.Label>
                            <Form.Select required disabled={isLoadingExhibits} value={registration.CompanyActivity} onChange={(e)=>companyActivityChanged(e.target.value)}>
                            <option value=''>{lang==1 ? "[ΕΠΙΛΕΞΤΕ ΔΡΑΣΤΗΡΙΟΤΗΤΑ ΕΤΑΙΡΙΑΣ]" : "[SELECT COMPANY ACTIVITY]"}</option>
                            {companyActivitiesList}
                            </Form.Select>
                            </>
                            :
                            <Alert variant="secondary">{lang==1 ? "Φόρτωση, παρακαλώ περιμένετε..." : "Loading, please wait..."}</Alert>

                        }

                    </Form.Group>  
                    :
                    <Form.Group className="mb-3" style={borderStyle}>
                        <Form.Label className="form-label-custom">{lang==1 ? "Δραστηριότητα Εταιρίας" : "Company Activity"}</Form.Label>
                        <Form.Control type="text" required value={registration.CompanyActivity} onChange={(e)=>setRegistration({...registration,CompanyActivity:e.target.value})}/>
                    </Form.Group>  
                    }


                    <br/>
                    {visitorsRegistrationSettings.ExhibitsFromList==1 && !isOnsite &&
                        <>
                            <Alert variant="light">
                                <div className="d-flex align-items-center w-100">
                                    {/* Left title */}
                                    <span className="fw-semibold">
                                    {lang==1 ? 'ΕΚΘΕΜΑΤΑ' : 'EXHIBITS'} ({selectedExhibits.length})&nbsp;&nbsp;&nbsp;
                                    <i>
                                    {showSemanticExhibits==1 ? lang==1 ? 'Βλέπετε τα συσχετιζόμενα με τη δραστηριότητα της εταιρίας σας εκθέματα' : `You see the exhibits related to your company's activity` : ''}
                                    </i>
                                    &nbsp;&nbsp;

                                    </span>

                                    {/* Right button */}
                                    {registration.CompanyActivity?.length>0 && visitorsRegistrationSettings.CompanyActivitiesFromList==1 && isLoadingExhibits==0 &&
                                        <Button
                                        size="sm"
                                        variant="outline-primary"
                                        className="ms-auto"
                                        onClick={(e) => {e.stopPropagation();setShowSemanticExhibits(showSemanticExhibits==1 ? 0 : 1)}}
                                        >
                                        {(showSemanticExhibits==1) ? (lang==1 ? 'Εμφάνιση Όλων' : 'Show All') : (lang==1 ? `Εμφάνιση Συσχετιζόμενων με ${registration.CompanyActivity}` : `Show Related to ${registration.CompanyActivity}`)}

                                        
                                        </Button>
                                     }
                                    &nbsp;&nbsp;
                                </div>
                            </Alert>         

                                

                                    {isLoadingExhibits &&
                                        <Alert variant="warning">Loading, please wait...</Alert>
                                    }
                                    {!isLoadingExhibits &&
                                    <>
                                    {exhibitsList}
                                    </>
                                    }
                        </>

                    }


  
               
                    <div style={{overflow:'auto',backgroundColor:'#fff',marginBottom:'20px',marginTop:'20px',fontSize:'12px'}}>
                    <br/><br/>
                    {lang==1 &&
                    <>
                    <b>ΣΗΜΑΝΤΙΚΗ ΕΝΗΜΕΡΩΣΗ ΣΧΕΤΙΚΑ ΜΕ ΤΑ ΠΡΟΣΩΠΙΚΑ ΣΑΣ ΔΕΔΟΜΕΝΑ</b><br/><br/>
                    Η ΔΕΘ-HELEXPO Α.Ε. λαμβάνει τα δεδομένα σας τα οποία φυλάσσονται σε
                    (ηλεκτρονικό ή/και φυσικό) αρχείο υπ’ ευθύνη της, τηρώντας όλα τα
                    κατάλληλα μέτρα ασφάλειας και σύμφωνα με την Πολιτική μας για την
                    Προστασία Προσωπικών Δεδομένων στον ιστότοπό
                    μας <a target="_blank" href="https://helexpo.gr/wp-content/uploads/2026/01/Privacy_Policy.pdf">https://helexpo.gr/wp-content/uploads/2026/01/Privacy_Policy.pdf</a>. (email επικοινωνίας
                    dpo@helexpo.gr)<br/><br/>
                    Με τη συμπλήρωση των στοιχείων σας για αποστολή πρόσκλησης αναγνωρίζετε και αποδέχεστε
                    ότι, στα πλαίσια διεξαγωγής της έκθεσης ενδέχεται να φωτογραφηθείτε, βιντεοσκοπηθείτε ή / και
                    ηχογραφηθείτε.<br/><br/>
                    Επίσης τεκμαίρεται η συγκατάθεσή σας για την με οποιονδήποτε τρόπο χρήση των ως άνω
                    εικόνων, φωτογραφιών ή / και ηχογραφήσεων σας από την ΔΕΘ HELEXPO AE και τους συνεργάτες
                    της, παραιτούμενος από κάθε αξίωσή σας από τη χρήση του ως άνω υλικού, η οποία περιλαμβάνει
                    ενδεικτικά τη δημοσίευση, αναμετάδοση και χρήση του αποκλειστικά για την προώθηση,
                    διαφήμιση, προβολή και παρουσίαση της Έκθεσης.<br/><br/>
                    </>
                    }
                    {lang==2 &&
                    <>
                    <b>IMPORTANT INFORMATION CONCERNING YOUR PERSONAL DATA</b><br/><br/>
                    TIF HELEXPO receives your data which are kept in an (electronic and/or
                    physical) archive under its responsibility, taking all the appropriate security
                    measures according our Personal Data Protection Policy on our website,
                    <a target="_blank" href="https://helexpo.gr/wp-content/uploads/2026/01/Privacy_Policy_eng.pdf">https://helexpo.gr/wp-content/uploads/2026/01/Privacy_Policy_eng.pdf</a>. (contact email dpo@helexpo,gr)
                    <br/><br/>
                    By submitting your details in order to receive the invitation to the trade show, you acknowledge and
                    agree to the fact that during your visit to exhibition you may be photographed, videotaped and/or
                    recorded by TIF HELEXPO SA and its employees.<br/><br/>
                    By submitting your details, it is presumed that you agree to the use of said images, photos and/or
                    recordings in any way by TIF HELEXPO SA and its employees, waivering all claims from the use of all
                    the above-mentioned material, which may include, but is not limited to the publication, broadcast or
                    any other use only for the promotion of the trade show.
                    <br/><br/>
                    </>
                    }

                    {isOnsite &&
                        <Alert variant="danger">
                            <b><h2>
                                Επιθυμείτε να λαμβάνετε ενημερωτικά και προωθητικά email για την KOSMIMA & συναφείς κλαδικές εκθέσεις και διοργανώσεις της ΔΕΘ-Helexpo; Μπορείτε να ανακαλέσετε τη συγκατάθεση σας οποτεδήποτε μέσω της απεγγραφής. Ναι ή Όχι;
                                </h2>
                            </b>
                        </Alert>
                    
                    }
                    <Alert variant="warning">
                    Επιθυμείτε να ενημερώνεστε ηλεκτρονικά ή μέσω ταχυδρομείου, για τη συγκεκριμένη έκθεση, στις διευθύνσεις που δηλώσατε;
                    <br/><br/>
                    Would you like to receive emails or regular mail, for the specific exhibition, to the above-mentioned addresses?

                    <br/><br/>
                    <Form.Group className="mb-3">
                    <Form.Select required onChange={(e)=>setGdprAnswer(e.target.value)}>
                        <option value=''>{lang==1 ? "[ΠΑΡΑΚΑΛΟΥΜΕ ΑΠΑΝΤΗΣΤΕ]"  : "[PLEASE ANSWER]"}</option>
                        <option value="1">{lang==1 ? "NAI"  : "YES"}</option>
                        <option value="0">{lang==1 ? "OXI"  : "NO"}</option>
                    </Form.Select>
                    </Form.Group>
                    </Alert>
                    
                    </div>
                    <p align="right">
                    <Button disabled={!(gdprAnswer && (!isLoadingExhibits) && (!isLoading))} variant="dark" type="submit" style={{width:'250px',height:'50px'}}>
                        {lang==1 ? "Εγγραφή"  : "Register"}

                    </Button>
                    </p>
                </Form>

                }

                {isRegistered==1 && 
                    <>
                        <Alert variant="success">
                            {lang==1 && 
                            <>
                           <h3> Η Εγγραφή σας έγινε με επιτυχία!</h3>
                            <br/>
                            Θα παραλάβετε ένα email από το no-reply@services-helexpo.gr στη διεύθυνση email {registration.Email}.
                            <br/><br/>
                            Εκεί θα είναι διαθέσιμες οι πληροφορίες για να παραλάβετε την κάρτα εισόδου σας.
                            <br/><br/>
                            Εάν δεν φανεί ότι παραλάβατε το email παρακαλούμε να κάνετε έλεγχο και στο spam folder (ανεπιθύμητα) των email σας.
                            </>
                            }


                            {lang==2 &&
                            <>
                            <h3>Your Registration has been successful!</h3>
                            <br/>        
                            You will receive an email from no-reply@services-helexpo.gr to the email address {registration.Email}.
                                <br/><br/>  
                            There you will find the information to collect your entry card.
                                <br/><br/>  
                            If you do not receive the email, please check your spam folder.
                            
                            </>
                            
                            }
                        </Alert>

                        {isOnsite &&
                        <Alert variant="info">
                                <Button variant="dark" onClick={()=>{setBadgeData({barCode:barCode,company:registration.Company,name:registration.PName});setShowBadge(true)}}>BADGE</Button>
                                &nbsp;&nbsp;
                                <Button variant="secondary" onClick={newVisitor}>{lang==1 ? "ΝΕΟΣ ΕΠΙΣΚΕΠΤΗΣ" : "NEW VISITOR"}</Button>
                            </Alert>
                        }


                    </>



                }


            </>
        }
        </>
    }

    <Modal show={showBadge} onHide={()=>setShowBadge(false)}>
        <Modal.Header closeButton>
            <Modal.Title>BADGE</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <BadgeQRCode ref={badgeRef} barCode={badgeData.barCode} company={badgeData.company} name={badgeData.name}/>
        </Modal.Body>
        <Modal.Footer>
            <Button variant="primary" onClick={handlePrintBadge}>
                {lang==1 ? "Εκτύπωση" : "Print"}
            </Button>
        </Modal.Footer>
    </Modal>

    <Modal show={searchResults.length>0} onHide={()=>setSearchResults([])} size="lg">
        <Modal.Header closeButton>
            <Modal.Title>{lang==1 ? "Αποτελέσματα Αναζήτησης" : "Search Results"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <Table striped bordered hover responsive>
                <thead>
                    <tr>
                        <th>Company</th>
                        <th>PName</th>
                        <th>Email</th>
                        <th>BarCode</th>
                    </tr>
                </thead>
                <tbody>
                    {searchResults.map((item,index)=>(
                        <tr key={index}>
                            <td>{item.Company}</td>
                            <td>{item.PName}</td>
                            <td>{item.Email}</td>
                            <td>
                                <Button variant="dark" size="sm" onClick={()=>{setBadgeData({barCode:item.BarCode,company:item.Company,name:item.PName});setShowBadge(true)}}>
                                    {item.BarCode}
                                </Button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </Modal.Body>
    </Modal>

    </Container>
  )
}
